/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A shipment lifecycle event a webhook can subscribe to. Mirrors the database enum company_webhook_event_type by constant name (the database spells the literals with a dot, `shipment.booked`; every generated client spells them with an underscore).
 * @export
 */
export const CompanyWebhookEventType = {
    ShipmentBooked: 'shipment_booked',
    ShipmentQuoted: 'shipment_quoted',
    ShipmentInTransit: 'shipment_in_transit',
    ShipmentDelivered: 'shipment_delivered',
    ShipmentCancelled: 'shipment_cancelled',
    ShipmentOnHold: 'shipment_on_hold',
    DraftCreated: 'draft_created',
    DocumentUploaded: 'document_uploaded',
    InvoicesUpdated: 'invoices_updated',
    TrackingLineAdded: 'tracking_line_added'
} as const;
export type CompanyWebhookEventType = typeof CompanyWebhookEventType[keyof typeof CompanyWebhookEventType];


export function instanceOfCompanyWebhookEventType(value: any): boolean {
    for (const key in CompanyWebhookEventType) {
        if (Object.prototype.hasOwnProperty.call(CompanyWebhookEventType, key)) {
            if (CompanyWebhookEventType[key as keyof typeof CompanyWebhookEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompanyWebhookEventTypeFromJSON(json: any): CompanyWebhookEventType {
    return CompanyWebhookEventTypeFromJSONTyped(json, false);
}

export function CompanyWebhookEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyWebhookEventType {
    return json as CompanyWebhookEventType;
}

export function CompanyWebhookEventTypeToJSON(value?: CompanyWebhookEventType | null): any {
    return value as any;
}

export function CompanyWebhookEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompanyWebhookEventType {
    return value as CompanyWebhookEventType;
}

